import React from "react";
import styled from "@emotion/styled";

import { OpportunityStage } from "./OpportunityStage";
import { GroupedStageOptions, StageOption } from "./utils";

export type StageRenderProps = {
  options: GroupedStageOptions[];
  isLoading: boolean;
};

export const renderStageOption = (
  label: React.ReactNode,
  value: React.ReactNode,
  options: GroupedStageOptions[],
) => {
  const labelAsString = label?.toString() || "";
  const selectedOption = options
    .flatMap((group) => group.options)
    .find((option) => option.value === value);
  const color = selectedOption?.color ?? "transparent";
  const iconColor = selectedOption?.iconColor ?? "white";
  const iconName = selectedOption?.iconName ?? "";

  return (
    <StageWrapper>
      <OpportunityStage
        label={labelAsString}
        color={color}
        iconColor={iconColor}
        iconName={iconName}
      />
    </StageWrapper>
  );
};

export const findStageOptionByValue = (
  value: string | null,
  options: GroupedStageOptions[],
): StageOption | undefined => {
  if (!value) return undefined;

  return options.flatMap((group) => group.options).find((option) => option.value === value);
};

export const StageWrapper = styled.div({
  lineHeight: "1",
});
